import {
  SET_CARD_FRAME_DETAILS_SEARCHING,
  SET_CARD_FRAME_DETAILS_LIST,
  SET_CARD_FRAME_DETAILS_SORT,
  SET_CARD_FRAME_DETAILS_QUERY,
  SET_CARD_FRAME_DETAILS_LIST_PAGE_SIZE,
  SET_CARD_FRAME_DETAILS_PAGE_NUM,
  SET_CARD_FRAME_DETAILS_LIST_PAGE_TOTAL,
} from './mutation-types.js'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageSize: 50,
  pageNum: 1,
  startDate: new Date().getTime() - 3600 * 1000 * 24 * 7,
  endDate: new Date().setHours(23, 59, 59, 999),
  nodeName: '',
})

const state = {
  searching: false,
  cardFrameDetailsList: [],
  sort: {},
  query: {
    pageSize: 50,
    pageNum: 1,
    startDate: new Date().getTime() - 3600 * 1000 * 24 * 7,
    endDate: new Date().setHours(23, 59, 59, 999),
    nodeName: '',
  },
  pageTotal: 0,
  initQuery: initQuery(),
}

const mutations = {
  [SET_CARD_FRAME_DETAILS_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_CARD_FRAME_DETAILS_LIST] (state, payload) {
    state.cardFrameDetailsList = payload
  },
  [SET_CARD_FRAME_DETAILS_SORT] (state, payload) {
    state.sort = payload
  },
  [SET_CARD_FRAME_DETAILS_QUERY] (state, payload) {
    state.query = {
      ...state.query,
      ...payload,
    }
  },
  [SET_CARD_FRAME_DETAILS_LIST_PAGE_SIZE] (state, payload) {
    state.query.pageSize = payload
  },
  [SET_CARD_FRAME_DETAILS_PAGE_NUM] (state, payload) {
    state.query.pageNum = payload
  },
  [SET_CARD_FRAME_DETAILS_LIST_PAGE_TOTAL] (state, payload) {
    state.pageTotal = payload
  },

}

const actions = {
  async getHistoryAbnormalJob ({commit, state}, payload) {
    try {
      commit(SET_CARD_FRAME_DETAILS_SEARCHING, true)
      let query = {}
      _.forIn(state.query, (v, k) => {
        if ((v instanceof Array && v.length > 0) || (v instanceof Array === false && v !== '')) {
          query[k] = v
        }
      })
      let params = {
        ...query,
        ...state.sort,
      }
      let {data: {items, total}} = await api.monitorApi.getHistoryAbnormalJob(params)
      commit(SET_CARD_FRAME_DETAILS_SEARCHING, false)
      commit(SET_CARD_FRAME_DETAILS_LIST, items)
      commit(SET_CARD_FRAME_DETAILS_LIST_PAGE_TOTAL, total)
      return items
    } catch (error) {
      commit(SET_CARD_FRAME_DETAILS_SEARCHING, false)
      commit(SET_CARD_FRAME_DETAILS_LIST_PAGE_TOTAL, 0)
      commit(SET_CARD_FRAME_DETAILS_LIST, [])
    }
  },
  async initHistoryAbnormalJob ({dispatch}, payload) {
    await dispatch('setCardFrameDetailsQuery', payload)
    await dispatch('getHistoryAbnormalJob')
  },
  setCardFrameDetailsQuery ({commit}, payload) {
    commit(SET_CARD_FRAME_DETAILS_QUERY, payload)
  },
  changeCardFrameDetailsSort ({commit, dispatch}, payload) {
    commit(SET_CARD_FRAME_DETAILS_SORT, payload)
    dispatch('setPageNum', 1)
  },
  // 改变每页显示条数
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_CARD_FRAME_DETAILS_LIST_PAGE_SIZE, payload.pageSize)
    dispatch('getHistoryAbnormalJob')
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_CARD_FRAME_DETAILS_PAGE_NUM, payload)
    dispatch('getHistoryAbnormalJob')
  },
  // 获取卡帧操作记录
  async getCardFrameDetailsOperateRecords ({commit, state, dispatch}, payload) {
    let data = await api.monitorApi.getAbnormalJobsOperateRecords(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
